import { deleteData, getData, postData } from "./common.service";

export async function getMonthlySalesPlans(text: string = '', skip = 0) {
    const qs = {
        where: {
            and: [
                {
                    or:
                        [
                            { month: { like: `.*${text}.*`, options: 'i' } },
                            { year: { like: `.*${text}.*`, options: 'i' } },
                            { district: { like: `.*${text}.*`, options: 'i' } },
                            { state: { like: `.*${text}.*`, options: 'i' } },
                            { subDistrict: { like: `.*${text}.*`, options: 'i' } },
                            { village: { like: `.*${text}.*`, options: 'i' } },
                            { region: { like: `.*${text}.*`, options: 'i'} }
                        ]
                }
            ]
        },
        order: 'created_date DESC',
        limit: 20,
        skip: skip
    };
    return getData('/monthly-sales-plans?filter=' + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}

export async function getMonthlySalesPlanForMe(territoryId: string, farmUserId: string, month: number, year: number) {
    const qs = {
        where: { and: [{ territoryId }, { farmUserId }, { month }, { year }] },
    };
    return getData('/monthly-sales-plans?filter=' + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}

export async function getAllSalesActivities() {
    const qs = {
        order: 'order ASC',
    };
    return getData("/sales-activity-types?filter=" + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}

export async function getSalesActivities(text: string = '', activityIds: string[] = [], skip = 0, filters: any = {}){
    
    const qs: any = {
        where: {
            or:[
                {comment: { like: `.*${text}.*`, options: 'i' }},
                {userid: { like: `.*${text}.*`, options: 'i' }},
                {servicedBy: { like: `.*${text}.*`, options: 'i' }},
            ]
            
        },
        order: 'date DESC',
        skip: skip,
        limit: 20,
        include: [
            {
              relation: "salesActivityType",
              scope: {
                fields: ["id", "description"]
                
              }
            }
          ]
       
    };

    // Apply group filter
    if (filters.group && filters.group.length > 0) {
        qs.where = {
            and: [
                { group: { inq: filters.group } },
                qs.where
            ]
        };
    }

    // Apply activity type filter
    if (filters.type && filters.type.length > 0) {
        if (qs.where.and) {
            qs.where.and.push({ salesActivityTypeId: { inq: filters.type } });
        } else {
            qs.where = {
                and: [
                    { salesActivityTypeId: { inq: filters.type } },
                    qs.where
                ]
            };
        }
    }

    // Apply servicedBy filter
    if (filters.servicedBy && filters.servicedBy.length > 0) {
        if (qs.where.and) {
            qs.where.and.push({ servicedBy: { inq: filters.servicedBy } });
        } else {
            qs.where = {
                and: [
                    { servicedBy: { inq: filters.servicedBy } },
                    qs.where
                ]
            };
        }
    }

    // Apply location filters
    if (filters.location) {
        const locationFilters: any = {};
        
        if (filters.location.state) {
            locationFilters.state = { eq: filters.location.state };
        }
        if (filters.location.district) {
            locationFilters.district = { eq: filters.location.district };
        }
        if (filters.location.subDistrict) {
            locationFilters.taluka = { eq: filters.location.subDistrict };
        }
        if (filters.location.area) {
            locationFilters.place = { eq: filters.location.area };
        }

        // Add location filters to where clause
        if (Object.keys(locationFilters).length > 0) {
            if (qs.where.and) {
                qs.where.and.push(locationFilters);
            } else {
                qs.where = {
                    and: [
                        qs.where,
                        locationFilters
                    ]
                };
            }
        }
    }

    // Legacy support: if activityIds are still passed, use them
    if(activityIds.length){
        if (qs.where.and) {
            qs.where.and.push({id: {inq: activityIds}});
        } else {
            qs.where = {
                and:[
                    {id: {inq: activityIds}},
                    qs.where
                ]
            };
        }
    }

    return getData("/sales-activities?filter=" + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}

export async function getSalesActivityByActivityTypeId(salesActivityIds: string[]){
    const qs = {
        where: {
            salesActivityTypeId: {
                inq: salesActivityIds
            }
            },
            fields: ['id']
        };
    return getData('/sales-activities?filter=' + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH, 
        sendTokenInHeader: true, 
    }).then(data => data.json())
};

export async function getPlanById(salesPlanId: string) {
    return getData(`/monthly-sales-plans/${salesPlanId}`, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}

export async function getCompletedSalesActivity(planId: string) {
    const qs = {
        where: {
            monthlySalesPlanId: planId
        }
    }
    return getData('/sales-activities?filter='+JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json())
}

export async function addSalesPlan(data: any) {
    return postData('/monthly-sales-plans', {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: data
    })
}

export async function updateSalesPlan(id: string, data: any) {
    return postData(`/monthly-sales-plans/${id}`, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        usePatchMethod: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: data
    })
}

export async function addSalesActivity(data: any) {
    return postData('/sales-activities', {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: data
    })
}

export async function getUpcomingActivityFollowups(servicedBy: string) {
    const endOfToday = new Date();
    endOfToday.setHours(23, 59, 59, 999);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const qs = {
        where: {
            and: [
                { followUpDate: { lte: endOfToday.toISOString() } },
                { followUpDate: { gte: thirtyDaysAgo.toISOString() } },
                { servicedBy },
            ]
        },
        include: [{ relation: 'salesActivityType', scope: { fields: ['id', 'description'] } }],
        order: 'followUpDate ASC',
        limit: 10,
    };
    return getData('/sales-activities?filter=' + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json());
}

export async function updateSalesActivity(id: string, data: any) {
    return postData(`/sales-activities/${id}`, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
        usePatchMethod: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: data
    })
}

export async function deleteSalesActivity(id: string) {
    return deleteData(`/sales-activities/${id}`, {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    })
}

export async function getSalesActivitiesForShare(servicedBy: string, date: Date) {
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0);

    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);

    const qs = {
        where: {
            and: [
                { servicedBy: { eq: servicedBy } },
                { date: { gte: startOfDay.toISOString() } },
                { date: { lte: endOfDay.toISOString() } }
            ]
        },
        order: 'date ASC',
        limit: 500,
        include: [
            {
                relation: "salesActivityType",
                scope: { fields: ["id", "description"] }
            }
        ]
    };

    return getData("/sales-activities?filter=" + JSON.stringify(qs), {
        basePath: process.env.REACT_APP_CORE_API_BASEPATH,
        sendTokenInHeader: true,
    }).then(data => data.json());
}
